import { Navigate, type RouteObject } from 'react-router';
import { ACCOUNT_TABS, accountTabPath } from './account.paths';
import { AccountPage } from './pages/AccountPage';

/** The signed-in person's own account, one route per tab. `/account/security` predates the Profile tab and keeps its address. */
export const ACCOUNT_ROUTES: RouteObject[] = [
  { path: 'account', element: <Navigate to={accountTabPath(ACCOUNT_TABS[0])} replace /> },
  ...ACCOUNT_TABS.map((tab) => ({ path: `account/${tab}`, element: <AccountPage tab={tab} /> })),
];
